import React, { useState, useRef } from 'react';
import { Breadcrumb, Row, Col, Spin } from 'antd';
import { Area } from '@ant-design/plots';
import Client from '../../../../../lib/gqlClient';
import { queryAndroidAppScore } from '../gqls'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useResizeObserver } from 'react-use-observer'
const ScorePage = (props) => {

    const navigate = useNavigate();

    const [isScoreLoading, setScoreLoading] = useState(false)

    const [listData, setListData] = useState([])
    const [scoreText, setScoreText] = useState(0)
    const [score1, setScore1] = useState(require('../../../../../static/img/icon-score11.png'))
    const [score2, setScore2] = useState(require('../../../../../static/img/icon-score11.png'))
    const [score3, setScore3] = useState(require('../../../../../static/img/icon-score11.png'))
    const [score4, setScore4] = useState(require('../../../../../static/img/icon-score11.png'))
    const [score5, setScore5] = useState(require('../../../../../static/img/icon-score11.png'))
    const [updateText, setUpdateText] = useState('--条评分  更新时间:--年--月--日');

    const [ref, resizeObserverEntry] = useResizeObserver();
    const [boxWidth, setBoxWidth] = useState(resizeObserverEntry.contentRect?.width || 0);
    const [boxHeight, setBoxHeight] = useState(resizeObserverEntry.contentRect?.height || 0);
    React.useEffect(() => {
        const { width = 0, height = 0 } = resizeObserverEntry.contentRect || {};
        if (width !== boxWidth) {
            setBoxWidth(width);
        }
        if (height !== boxHeight) {
            setBoxHeight(height);
        }
    });
    React.useEffect(() => {
        React.graph && React.graph.resize(boxWidth, boxHeight);
    }, [boxWidth, boxHeight]);

    React.useEffect(() => {
        getAndroidAppScore();
    }, [])

    function onStart() {
        props.setNewKey('/developerCenter/scoreOrComments/myVitals/android')
        navigate('/developerCenter/scoreOrComments/myVitals/android')
    }
    function getAndroidAppScore() {
        setScoreLoading(true)
        Client(
            queryAndroidAppScore,
            {
                app: 'ig',
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setScore(res.data.androidAppScore.latestScore)
                const time = res.data.androidAppScore.latestAt
                const yar = time.substring(0, 4)
                const moth = time.substring(5, 7)
                const day = time.substring(8, 10)
                setUpdateText(res.data.androidAppScore.total + '条评分  更新时间:' + yar + "年" + moth + "月" + day + "日")

                let data = [{}];
                const list = res.data.androidAppScore.data
                list.map((item, index) => {
                    data[index] = {
                        日期: item.date.substring(0, 10),
                        评分: item.score,
                    }
                })

                setListData(data)
                setScoreLoading(false)
            }

        }).catch(e => {
            // console.log(e);
            setScoreLoading(false)
        })
    }
    // 评分
    function setScore(score) {
        setScoreText(score)
        if (score >= 1) {
            setScore1(require('../../../../../static/img/icon-score10.png'))
        } else if (1 - score < 1) {
            setScore2(decimalScore(0, score))
        } else {
            setScore1(require('../../../../../static/img/icon-score11.png'))
        }
        if (score >= 2) {
            setScore2(require('../../../../../static/img/icon-score10.png'))
        } else if (2 - score < 1) {
            setScore2(decimalScore(1, score))
        } else {
            setScore2(require('../../../../../static/img/icon-score11.png'))
        }
        if (score >= 3) {
            setScore3(require('../../../../../static/img/icon-score10.png'))
        } else if (3 - score < 1) {
            setScore3(decimalScore(2, score))
        } else {
            setScore3(require('../../../../../static/img/icon-score11.png'))
        }
        if (score >= 4) {
            setScore4(require('../../../../../static/img/icon-score10.png'))
        } else if (4 - score < 1) {
            setScore4(decimalScore(3, score))
        } else {
            setScore4(require('../../../../../static/img/icon-score11.png'))
        }
        if (score >= 5) {
            setScore5(require('../../../../../static/img/icon-score10.png'))
        } else if (5 - score < 1) {
            setScore5(decimalScore(4, score))
        } else {
            setScore5(require('../../../../../static/img/icon-score11.png'))
        }
    }
    function decimalScore(number, score) {
        switch (score * 10 - number * 10) {
            case 1:
                return require('../../../../../static/img/icon-score1.png')
            case 2:
                return require('../../../../../static/img/icon-score2.png')
            case 3:
                return require('../../../../../static/img/icon-score3.png')
            case 4:
                return require('../../../../../static/img/icon-score4.png')
            case 5:
                return require('../../../../../static/img/icon-score5.png')
            case 6:
                return require('../../../../../static/img/icon-score6.png')
            case 7:
                return require('../../../../../static/img/icon-score7.png')
            case 8:
                return require('../../../../../static/img/icon-score8.png')
            case 9:
                return require('../../../../../static/img/icon-score9.png')
            default:
                return require('../../../../../static/img/icon-score11.png')
        }
    }
    return (
        <div ref={ref} style={{ height: '656px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
            {/* 标题头 */}
            <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>{'Ratings & Reviews'}</a></Breadcrumb.Item>
                <Breadcrumb.Item><a style={{ fontSize: '12px' }}>iGluco Android</a></Breadcrumb.Item>
            </Breadcrumb>
            <div style={Styles.title}>应用评分</div>
            <div style={{ marginTop: '30px', marginRight: '95px', }}>
                <Row style={{ marginTop: '26px', marginLeft: '56px', height: '128px' }}>
                    <Col >
                        {/* 应用icon */}
                        <img src={require('../../../../../static/img/icon-iGluco.png')} alt="logo" height={120} />
                    </Col>
                    <Col style={{ marginLeft: '24px' }}>
                        <div style={{ fontSize: '32px', fontWeight: 'normal', lineHeight: '47.98px' }}>
                            iGluco
                        </div>
                        <div style={{ margingTop: '10px', height: '1px', backgroundColor: '#D8D8D8', width: boxWidth - 295 }}></div>
                        <Row style={{ height: '25px', marginTop: '10px', marginBottom: '13px' }}>
                            <Col style={{ textAlign: 'center', fontSize: '16px', marginRight: '8px', lineHeight: '24px' }}>
                                {scoreText}
                            </Col>
                            <Col style={{ marginRight: '10px' }}><img src={score1} alt="logo" height={25} /></Col>
                            <Col style={{ marginRight: '10px' }}><img src={score2} alt="logo" height={25} /></Col>
                            <Col style={{ marginRight: '10px' }}><img src={score3} alt="logo" height={25} /></Col>
                            <Col style={{ marginRight: '10px' }}><img src={score4} alt="logo" height={25} /></Col>
                            <Col><img src={score5} alt="logo" height={25} /></Col>
                        </Row>
                        <div style={{ fontSzie: '14px' }}>
                            {updateText}
                        </div>
                    </Col>
                </Row>
                <div style={{ color: '#2657F9', fontSize: '16px', marginLeft: '56px', marginTop: '20px', }}>评分趋势</div>
            </div>
            <Spin size="large" tip="Loading..." spinning={isScoreLoading}>
                <Area{...{
                    data: listData,
                    xField: '日期',
                    yField: '评分',
                    xAxis: {
                        range: [0, 1]
                    },
                    yAxis: {
                        maxTickCount:10,
                    },
                    smooth: true,
                    fill: '#2657F9',

                }} style={{ height: '246px', marginTop: '25px', marginBottom: '50px', marginLeft: '115px', marginRight: '95px' }} />
            </Spin>
        </div>
    );

}

const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
}
export default ScorePage